import { Box, Typography, useMediaQuery } from "@mui/material";
import { ContainerTitleStyled } from "./container-title.styles";
import { PrimaryButton } from "../button/button";
import { ContainerTitleProps } from "./types";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "styled-components";

const ContainerTitle: React.FC<ContainerTitleProps> = ({
  title,
  showButton,
  buttonLabel,
  buttonAction,
  backButtonAction,
  showBackButton,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const handleBack = () => {
    if (backButtonAction) backButtonAction();
    else navigate(-1); // Go back to the previous page
  };
  return (
    <ContainerTitleStyled>
      <Box className="title-and-back-icon">
        {showBackButton && (
          <span onClick={handleBack} className="back-icon">
            <ArrowBackIcon />
          </span>
        )}
        <Typography className="title">{title}</Typography>
      </Box>
      {showButton && (
        <PrimaryButton onClick={buttonAction}>
          {isMobile ? buttonLabel?.split(" ")?.[0] : buttonLabel}
        </PrimaryButton>
      )}
    </ContainerTitleStyled>
  );
};

export default ContainerTitle;
